const Fetcher = require('od-modules/utils/fetcher');
var trackingUtils = require('../modules/utils/tracking.utils');
var postBookingUtils = require('../modules/utils/post_booking.utils');
var postBookingBagsCollection = require('../modules/collections/post_booking_bags.collection').getInstance();
var postBookingPayment = require('../modules/models/post_booking_payment.model').getInstance();
var url = Odigeo.Settings.getProperty('postBookingServiceUrlFormatter')('addBags');
const ecommerceUrl = Odigeo.Settings.getProperty('postBookingServiceUrlFormatter')('getBagsEcommerceData');

var responseToEventError = {
    CC_ERR: 'purchasePaymentError',
    PAY_ERR: 'purchasePaymentError',
    BAG_SEL_ERR: 'purchaseError',
    VAL_ERR: 'purchaseError',
    UPDATE_WNG: 'purchaseOk',
    PROV_WNG: 'purchaseOk',
};

var errorTypeForTracking = {
    INVALID_CARD_NUMBER: 'cccard_number_submit_invalid_error',
    WRONG_CVV2: 'cccard_cvv_submit_invalid_error',
    WRONG_CREDITCARD_EXPIRATION_DATE: 'cccard_expiration_submit_invalid_errors',
    CARD_EXPIRED: 'cccard_expiration_submit_invalid_errors',
    DATA_VALIDATION_ERROR: 'cccard_owner_submit_invalid_error',
    UNKNOWN: 'other',
};

function hasAvailableBags(data) {
    if (!Odigeo._.has(data, 'availableAncillariesOptionsDTO.collectionMethods') ||
        Odigeo._.isEmpty(Odigeo._.filter(data.availableAncillariesOptionsDTO.collectionMethods, {collectionMethodType: 'CREDITCARD'}))) {
        return false;
    }

    if (Odigeo._.has(data, 'availableAncillariesOptionsDTO.ancillaryOptionsContainer.baggageResultsResponse') &&
        !Odigeo._.isEmpty(data.availableAncillariesOptionsDTO.ancillaryOptionsContainer.baggageResultsResponse)) {
        var baggageResults = data.availableAncillariesOptionsDTO.ancillaryOptionsContainer.baggageResultsResponse;
        var travelerTypes = Odigeo._.map(data.availableAncillariesOptionsDTO.travellers, function(traveler) {
            return traveler.travellerType.toUpperCase();
        });

        return Odigeo._.some(baggageResults, function(baggageResult) {
            if (Odigeo._.includes(travelerTypes, baggageResult.travellerType.toUpperCase())) {
                return Odigeo._.some(baggageResult.baggageConditions, function(baggageCondition) {
                    return !Odigeo._.isEmpty(baggageCondition.selectableBaggage);
                });
            }
            return false;
        });
    }

    return false;
}

module.exports = {
    modelClass: require('../modules/models/post_booking_bags_and_seats.model'),

    // initialization
    init: function() {
        this.bindEvents();
    },

    bindEvents: function() {
        this.listenTo(postBookingBagsCollection, 'add', this.bagsCollectionChanged);
        this.listenTo(postBookingBagsCollection, 'remove', this.bagsCollectionChanged);
        this.view.listenTo(this.model, 'change:phase', this.view.render);
        postBookingUtils.hideOneClickCheckoutOnShoppingPhase(this.view.oneClickCheckoutContainer,
            this, this.model.phases.SHOPPING, Odigeo.AB.isOneClickCheckout);
    },

    //
    // handlers
    //
    bagsCollectionChanged: function() {
        var current = this.model.get('phase');
        var next = current;
        if (!this.hasSelectedAnyBags() || Odigeo.AB.isOneClickCheckout) {
            next = this.model.phases.SHOPPING;
        } else if (current === this.model.phases.SHOPPING) {
            next = this.model.phases.CHECKOUT;
        }
        this.model.set('phase', next);

        if (current === next) {
            this.view.render();
        }
    },

    //
    // public methods
    //

    clearBagSelections: function() {
        postBookingBagsCollection.reset();
    },

    checkAvailableBags: function(data) {
        var message = hasAvailableBags(data) ? 'bagsAvailable' : 'noBagsAvailable';

        Odigeo.trigger(this.id + ':' + message, data);
    },

    showAddBags: function(bookingInfo, ancillaryInfo, showFlightInfo) {
        this.model.loadInfo(bookingInfo, ancillaryInfo, showFlightInfo);
        this.model.set('phase', this.model.phases.SHOPPING);
        postBookingUtils.initOneClickCheckout(this.view.oneClickCheckoutContainer,
            bookingInfo, Odigeo.AB.isOneClickCheckout);
    },

    showSuccess: function() {
        this.model.set('phase', this.model.phases.SUCCESS);
    },

    showPaymentFailure: function() {
        this.model.set('phase', this.model.phases.PAYMENT_FAILURE);
    },

    showFailure: function() {
        this.model.set('phase', this.model.phases.FAILURE);
    },

    open: function() {
        this.model.initialize();
        this.view.isOpen = true;
        this.view.open();
        this.trackPage('add');
    },

    close: function() {
        this.view.isOpen = false;
        this.view.close();
    },

    moveToPayment() {
        this.view.moveToPayment();
    },

    selectBag: function(travelerIndex, segmentIndex, bagIndex) {
        var traveler = this.model.getTraveler(travelerIndex);
        var travelerType = traveler.travellerType.toUpperCase();
        var selectableBag = this.model.getSelectableBag(travelerType, segmentIndex, bagIndex);

        postBookingBagsCollection.removeBag(travelerIndex, segmentIndex);
        postBookingBagsCollection.addBag(travelerIndex, segmentIndex, bagIndex, selectableBag);
    },

    removeBag: function(travelerIndex, segmentIndex) {
        postBookingBagsCollection.removeBag(travelerIndex, segmentIndex);
    },

    getTotalPrice: function() {
        return postBookingBagsCollection.getTotalPrice();
    },

    getCurrencyConfig: function() {
        return postBookingBagsCollection.getCurrencyConfig();
    },

    getTotalPieces: function() {
        return postBookingBagsCollection.getTotalPieces();
    },

    getAverageFee() {
        return this.hasSelectedAnyBags() ? Odigeo.Utils.formatCurrency(postBookingBagsCollection.getAverageFee()) : 0;
    },

    getPriceBreakdown: function() {
        return postBookingBagsCollection.getPriceBreakdown();
    },

    hasSelectedAnyBags: function() {
        return postBookingBagsCollection.hasSelectedAnyBags();
    },

    isPaymentMethodValid: function() {
        return this.model.get('paymentMethodValid');
    },

    isAcceptedCreditCardType: function() {
        var collectionMethods = postBookingUtils.getCollectionMethods(this.model.get('ancillaryInfo'));
        var creditCardTypeCode = this.model.get('creditCardTypeCode');
        return postBookingUtils.isAcceptedCreditCardType(collectionMethods, creditCardTypeCode);
    },

    allowPurchase: function() {
        return this.isPaymentMethodValid() && this.isAcceptedCreditCardType();
    },

    onCheckoutConfirm() {
        this.trackCheckoutEvent('baggage_offline_add', 'baggage_offline_click_pay_success');
        this.trackPage('confirmation');
        this.requestEcommerceData();
        this.view.onCheckoutConfirm();
    },

    requestEcommerceData: function() {
        var data = this.buildAddAncillariesRequest(postBookingBagsCollection, postBookingPayment);
        // eslint-disable-next-line no-restricted-properties
        Fetcher.post(ecommerceUrl + '/' + this.model.getBookingId(), data).json()
            .then((response) => this.ecommerceRequestSuccessHandler(response));
    },

    ecommerceRequestSuccessHandler: function(response) {
        trackingUtils.trackEcommerce(response, 'postBookingAncillaries');
    },

    onCheckoutPaymentRetry() {
        this.trackCheckoutEvent('baggage_offline_add', 'baggage_offline_click_pay_error');
        this.trackPage('confirmation_error');
        this.view.onCheckoutPaymentRetry();
    },

    onCheckoutInteractionNeeded() {
        this.trackCheckoutEvent('baggage_offline_add', 'baggage_offline_click_pay_interaction');
        this.trackPage('interaction_needed');
        this.view.onCheckoutInteractionNeeded();
    },

    hasSelectedBagForSegment: function(traveler, segmentIndex) {
        return postBookingBagsCollection.hasSelectedBagForSegment(traveler.travellerNumber, segmentIndex);
    },

    getSelectedBagForSegment: function(traveler, segmentIndex) {
        return postBookingBagsCollection.getSelectedBagForSegment(traveler.travellerNumber, segmentIndex);
    },

    setCardData: function(isValid, paymentDetails) {
        this.model.set('paymentMethodValid', isValid);
        if (Odigeo.AB.isOneClickCheckout) {
            this.view.oneClickCheckoutContainer.execute('setCardData', paymentDetails);
        }
        postBookingPayment.set('paymentDetails', paymentDetails);
        this.view.render();
    },

    setCreditCardTypeCode: function(creditCardTypeCode, creditCardTypeName) {
        this.model.set({
            creditCardTypeCode: creditCardTypeCode,
            creditCardTypeName: creditCardTypeName,
        });
        if (Odigeo.AB.isOneClickCheckout) {
            this.view.oneClickCheckoutContainer.execute('setCreditCardTypeCode', creditCardTypeCode);
        }
        this.view.render();
    },

    trackNumBaggages: function(step) {
        var bagsCount = this.getTotalPieces();
        var totalBagsCount = bagsCount + this.model.getAllIncludedBagsCount();
        var itinerary = this.model.getItineraryInfo();
        var tripType = itinerary.tripType === 'ONE_WAY' ? 'OW' : itinerary.tripType === 'ROUND_TRIP' ? 'RT' : 'MD';
        var flightType = {
            'departure': 1,
            'return': 2,
            'multiple': 3,
        };
        var baggageSelection = this.model.baggageSelection;
        var flights;
        var paxWithBags = 0;
        if (baggageSelection) {
            var multipleSegments = baggageSelection.length > 1;
            if (!multipleSegments) {
                flights = baggageSelection[0].segmentIndex === 0 ? flightType.departure : flightType.return;
            } else {
                flights = flightType.multiple;
            }
            paxWithBags = baggageSelection.map(function(passengersWithBags) {
                return passengersWithBags.travelerIndex;
            });
            paxWithBags = Odigeo._.uniq(paxWithBags);
        }
        trackingUtils.trackEventWithCategory(
            'my_area_trips_details',
            'baggage_offline_add',
            'num_baggages_' + step + ':' + bagsCount +
            '_type:' + tripType +
            '_flig:' + flights +
            '_pax:' + paxWithBags.length +
            '_num:' + totalBagsCount
        );
    },

    buildAncillarySelectionList(bagsSelection) {
        const buildBagSelectionRequest = function(bagSelection) {
            return {
                segmentId: bagSelection.segmentIndex,
                totalPrice: {
                    amount: bagSelection.amount.toFixed(2),
                    currencyCode: bagSelection.currencyCode,
                },
                baggageFee: {
                    amount: bagSelection.baggageFee.amount.toFixed(2),
                    currencyCode: bagSelection.baggageFee.currencyCode,
                },
                pieces: bagSelection.pieces,
                kilos: bagSelection.kilos,
            };
        };
        const buildTravelerBagsSelectionRequest = function(travelerIndex, travelerBagsSelection) {
            const bagsSelectionRequest = Odigeo._.map(travelerBagsSelection, buildBagSelectionRequest);
            return {
                travellerNumber: travelerIndex,
                baggageSelectionList: bagsSelectionRequest,
            };
        };

        const bagsSelectionByTraveler = Odigeo._.groupBy(bagsSelection.toJSON(), 'travelerIndex');

        return Odigeo._.reduce(bagsSelectionByTraveler, function(acc, travelerBagsSelection, travelerIndex) {
            acc.push(buildTravelerBagsSelectionRequest(travelerIndex, travelerBagsSelection));
            return acc;
        }, []);
    },

    buildAddAncillariesRequest: function(bagsSelection, postBookingPayment) {
        const creditCardDetails = postBookingPayment.get('paymentDetails').creditCardDetails;
        const bagsByTravelerRequest = this.buildAncillarySelectionList(bagsSelection);
        return {
            ancillarySelectionList: bagsByTravelerRequest,
            chargeBookingRequest: {
                amount: {
                    amount: bagsSelection.getTotalPrice().toFixed(2),
                    currencyCode: bagsSelection.getCurrencyCode(),
                },
                collectionCurrency: bagsSelection.getCurrencyCode(),
                collectionParameters: {
                    creditCardCollectionParameters: {
                        typeInfo: 'creditCardCollectionParameters',
                        typeCode: creditCardDetails.typeCode,
                        owner: creditCardDetails.owner,
                        number: creditCardDetails.number,
                        expiryDate: creditCardDetails.expirationMonth + creditCardDetails.expirationYear,
                        cvv2: creditCardDetails.securityNumber,
                    },
                },
            },
        };
    },
    purchaseBags: function() {
        var data = this.buildAddAncillariesRequest(postBookingBagsCollection, postBookingPayment);
        Fetcher.post(url + '/' + this.model.getBookingId(), data).json()
            .then((response) => this.requestSuccessHandler(response))
            .catch((response) => this.requestErrorHandler(response))
            .finally(() => this.clearBagSelections());
    },

    requestSuccessHandler: function(response) {
        if (!Odigeo._.isEmpty(response.errors)) {
            var error = response.errors[0];
            this.trackPage('confirmation_error');
            this.requestTracking(response);
            Odigeo.trigger(this.id + ':purchaseError', 'bags', error.message);
        } else {
            var res = response.addAncillariesResponseDTO;
            this.requestTracking(res);
            if (res.success) {
                trackingUtils.trackEcommerce(response.analyticsEcommerce, 'postBookingAncillaries');
                this.trackPage('confirmation');
                Odigeo.trigger(this.id + ':purchaseOk', 'bags');
            } else {
                this.trackPage('confirmation_error');
                Odigeo.trigger(this.id + ':' + (responseToEventError[res.code] || 'purchaseError'), 'bags');
            }
        }
    },

    trackPage: function(page) {
        trackingUtils.trackPage('PB/bag/' + page, {
            funnel: false,
        });
    },

    requestTracking: function(response) {
        var label = 'success_';
        var result = 'OK';
        var errorMsg = response.message;
        if (!response.success) {
            label = response.code === 'PROV_WNG' || response.code === 'UPDATE_WNG' ? 'success_' : 'fail_';
            result = response.code === 'PAY_ERR' && Odigeo._.find(errorTypeForTracking, function(errorType, errorCode) {
                return Odigeo._.contains(errorMsg, errorCode);
            });
            result = result || (response.code === 'PROV_WNG' ? 'manual' : response.code === 'UPDATE_WNG' ? 'robot' : 'other');
        }
        trackingUtils.trackEventWithCategory(
            'my_area_trips_details',
            'baggage_offline_add',
            'baggage_offline_click_pay_' + label + result);
    },

    trackCheckoutEvent(action, label) {
        trackingUtils.trackEventWithCategory(
            'my_area_trips_details',
            action,
            label);
    },

    requestErrorHandler: function(response) {
        this.trackPage('confirmation_error');
        Odigeo.trigger(this.id + ':purchaseError', 'bags', response);
    },

    selectAncillariesAndAddToShoppingBasket() {
        postBookingUtils.selectAncillariesAndAddToShoppingBasket(
            this.view.oneClickCheckoutContainer,
            this.model.getBookingId(),
            this.buildAncillarySelectionList(postBookingBagsCollection),
            'productIds.BAGGAGE',
            this.showFailure.bind(this)
        );
    },
};
